define('views/shared/form/input/ssn_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/form/input/ssn_component.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'form-input',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            // 'keyup input': 'validateSSN',
            'keyup input': 'keyupValidateSSN',
            'blur input'   : 'ssnBlur'
        },

        ssn: {
            touched: false,
            complete: false,
            valid: false,
            empty: true,
            focused: false
        },

        initialize: function(options){
            options = options || {};

            this.field = options.field;

            // In case of the omission of the error object within the content file
            if(!this.field.error){
                this.field.error = {};
            }

            this.is_valid = false;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;
            
            // if autocomplete is false and we're in chrome
            if (!this.field.autocomplete && window.chrome) {  
                this.field.autocomplete = 'autocomplete-off-' + (new Date()).getTime();
            }             

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            this.render();
            
        },

        getValue: function(){
            return encrypt(this.$el.find('input').val());
        },

        showError: function(){

            // If ssn is not valid, empty, and has not been touched
            if(!this.is_valid && this.ssn.empty && !this.ssn.touched){
                this.$('.js-form-input-feedback').html(this.field.error.empty);
            } else if(!this.is_valid && !this.ssn.focused && !this.ssn.empty){
                // If ssn is not valid and not in focus
                this.$('.js-form-input-feedback').html(this.field.error.invalid);
            } else {
                this.removeError();
            }
            
        },

        removeError: function(){
            this.$('.js-form-input-feedback').html('');
        },

        validateSSN: function(){
            var ssn_input = this.$el.find('input'),
                value = Number(ssn_input.val()),
                value_length = ssn_input.val().length != 4;

            this.ssn.touched = true;

            if(!value || value == ''){

                this.ssn.empty = true;
                this.is_valid = false;
                this.ssn.complete = false;

            } else if(!_.isNumber(value) || value_length){

                this.is_valid = false;
                this.ssn.empty = false;
                this.ssn.complete = false;

            } else {

                this.is_valid = true;
                this.ssn.empty = false;
                this.ssn.complete = true;

            }

            if(!this.is_valid && this.ssn.empty){
                this.showError();
            } else if(!this.is_valid){
                this.showError();
            } else {
                this.removeError();
            }

        },

        keyupValidateSSN: function(e){
            
            switch(true){
                case e.keyCode == 37:   // Left Arrow
                case e.keyCode == 39:   // Right Arrow
                case e.keyCode == 8:    // Backspace
                case e.keyCode == 46:   // Delete
                case e.keyCode == 9:    // Tab
                case e.keyCode >= 48 && e.keyCode <= 57:   // Numbers
                case e.keyCode >= 96 && e.keyCode <= 105:  // Numberpad
                    
                    this.ssn.focused = true;
                    this.validateSSN(e);

                    break;
                default:
                    return false;
                    break;
            }
            
        },

        ssnBlur: function(){
            this.ssn.focused = false;
            this.validateSSN();
        },

        close: function(){}
    });
});

